import Button from '@sportnet/ui/Button';
import {
  ContextBar,
  ContextBarItem,
  ContextBarSpacer,
} from '@sportnet/ui/ContextBar';
import Segment from '@sportnet/ui/Segment';
import Sidebar from '@sportnet/ui/Sidebar';
import { Table, Tbody, Td, Th, Thead, Tr } from '@sportnet/ui/Table';
import AppContext from '@sportnet/ui/TheLayout/AppContext';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Api from '../../../../Api';
import Layout from '../../../../components/Layout';
import { __ } from '../../../../utilities';
import { aclSelector } from '../../../App/selectors';
import {
  orgEntitySelector,
  orgIsErrorSelector,
  orgIsFetchingSelector,
} from '../selectors';
import Tabber, { TABS } from '../Tabber';
import ShortnameForm from './form';

export const Faded = styled.span`
  color: ${({ theme }) => theme.color.fadedText};
`;

const ConditionalStrong = styled.span`
  font-weight: ${({ isStrong }) => (isStrong ? 'bold' : 'normal')};
`;

const ShortnamesList = ({
  org,
  match: {
    params: { appspace, organizationId, orgProfileId },
  },
  isFetching,
}) => {
  const [editingItem, setEditingItem] = useState();
  const [isFetchingShortnames, setIsFetchingShortnames] = useState(false);
  const [shortnames, setShortnames] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [lastDataFetch, setLastDataFetch] = useState();

  useEffect(() => {
    setIsFetchingShortnames(true);
    Api.crmPPOShortnames(appspace, orgProfileId)
      .then(({ shortnames }) => {
        setShortnames(shortnames);
      })
      .catch(e => {
        alert(
          e.details
            ? e.details.userinfo || __('Pri získavaní skratiek nastala chyba')
            : e,
        );
      })
      .finally(() => {
        setIsFetchingShortnames(false);
      });
  }, [appspace, organizationId, orgProfileId, lastDataFetch]);

  const submit = async data => {
    let promis = null;
    if (data._id) {
      promis = Api.crmPPOShortnameUpdate(orgProfileId, data._id, appspace, {
        data: {
          shortname: data.shortname,
        },
      });
    } else {
      promis = Api.crmPPOShortnameCreate(appspace, orgProfileId, {
        data: {
          shortname: data.shortname,
        },
      });
    }
    return promis
      .then(() => {
        setEditingItem(null);
        setLastDataFetch(new Date());
      })
      .catch(e => {
        if (e.details && e.details.name === 'DUPLICATED_CONFLICT') {
          alert(__('Zadaný kód už používate pri inej organizácii'));
        } else {
          alert(
            e.details
              ? e.details.userinfo || __('Pri ukladaní kódu nastala chyba')
              : e,
          );
        }
      });
  };
  const onDelete = async ({ _id: itemId }) => {
    if (!window.confirm(__('Prajete si odstrániť kód organizácie?'))) {
      return false;
    }
    setIsDeleting(true);
    return Api.crmPPOShortnameDelete(orgProfileId, itemId, appspace)
      .then(() => {
        setEditingItem(null);
        setShortnames(shortnames.filter(({ _id }) => _id !== itemId));
      })
      .catch(e => {
        alert(
          e.details
            ? e.details.userinfo ||
                __('Pri odstraňovaní kódu organizácie nastala chyba')
            : e,
        );
      })
      .finally(() => {
        setIsDeleting(false);
      });
  };

  return (
    <Layout
      bottomFixed={
        !shortnames.find(
          ({ org_profile_id }) => org_profile_id === appspace,
        ) && (
          <ContextBar>
            <ContextBarSpacer />
            <ContextBarItem>
              <Button
                primary
                onClick={() => {
                  setEditingItem({});
                }}
              >
                {__('Pridať skratku')}
              </Button>
            </ContextBarItem>
          </ContextBar>
        )
      }
    >
      <AppContext
        title={org && org.full_name}
        backUrl={`/admin/${appspace}/organizations`}
        breadcrumbs={[
          {
            name: __('Späť na zoznam'),
            url: `/admin/${appspace}/organizations`,
          },
        ]}
      />
      <Tabber activeTab={TABS.shortNames} />
      <Segment>
        <Segment raised loading={isFetching || isFetchingShortnames}>
          <Table>
            <Thead>
              <Tr>
                <Th>{__('Organizácia')}</Th>
                <Th>{__('Kód')}</Th>
              </Tr>
            </Thead>
            <Tbody>
              {shortnames.map(item => {
                const trProps = {
                  key: item._id,
                  onClick: () => {
                    setEditingItem(item);
                  },
                };
                return (
                  <Tr {...trProps}>
                    <Td>
                      <ConditionalStrong
                        isStrong={item.org_profile_id === appspace}
                      >
                        {item.org_name}
                        <br />
                        <Faded>{item.org_profile_name}</Faded>
                      </ConditionalStrong>
                    </Td>
                    <Td>
                      <ConditionalStrong
                        isStrong={item.org_profile_id === appspace}
                      >
                        {item.shortname}
                      </ConditionalStrong>
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </Segment>
      </Segment>
      <Sidebar
        header={__('Kód organizácie')}
        visible={editingItem}
        onClose={() => {
          setEditingItem(null);
        }}
      >
        {editingItem && (
          <ShortnameForm
            data={editingItem}
            onSubmit={submit}
            onDelete={onDelete}
            deleting={isDeleting}
          />
        )}
      </Sidebar>
    </Layout>
  );
};

const mapStateToProps = (
  state,
  {
    match: {
      params: { organizationId },
    },
  },
) => ({
  org: orgEntitySelector(state, organizationId),
  didFailed: orgIsErrorSelector(state, organizationId),
  isFetching: orgIsFetchingSelector(state, organizationId),
  acl: aclSelector(state),
});

export default connect(mapStateToProps)(ShortnamesList);
